import { MODAL } from '../actions/types';

export default (state = { isOpened: false }, action) => {
  switch (action.type) {
    case MODAL:
      return {
        isOpened: action.payload,
      };
    default:
      return state;
  }
};
